import React from "react";
import moment from "moment";

import { TableColumn, TableRow } from "components/Table/Table.js";

export default class RunRow extends React.PureComponent {
  render() {
    const { recipe, onClick, isHighlight, onHover } = this.props;

    return (
      <TableRow
        isHighlight={isHighlight}
        onMouseEnter={onHover ? () => onHover(recipe.id) : () => {}}
        onMouseLeave={onHover ? () => onHover(undefined) : () => {}}
      >
        <TableColumn>
          <a onClick={() => onClick()}>{recipe.name}</a>
        </TableColumn>
        <TableColumn title={moment.utc(recipe.createdDate).local().format("MMMM Do YYYY, h:mm:ss a")}>
          {moment.utc(recipe.createdDate).local().fromNow()}
        </TableColumn>
      </TableRow>
    );
  }
}
